import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Space } from "@masterteam/mt-design-react";

import DetailsModal from "../../../DoughnutChart/DetailsModal";

import { useIsAr } from "../../../../Hooks";

import "./style.scss";

const initialModalState = {
  isOpen: false,
  data: null,
};

const BarChart = ({ data, statuses, isProject }) => {
  const [isAr] = useIsAr();
  const [detailsModal, setDetailsModal] = useState(initialModalState);
  const key = isProject ? "ProjectChart" : "KPIChart";

  const getStatusColor = (value) => {
    const status = statuses.find((e) => e.Code === value);

    return status.Color;
  };

  return (
    <Space
      direction="vertical"
      size="small"
      className="bar-chart"
      justify="center"
      align="center"
    >
      <div className="bar-chart__total-count">
        {data?.[key]?.Count}{" "}
        <FormattedMessage id={isProject ? "common.projects" : "common.kpis"} />
      </div>

      <div
        className="bar-chart__chart"
        onClick={() => {
          if (data?.[key]?.List.length)
            setDetailsModal({ isOpen: true, data: data?.[key]?.List });
        }}
      >
        {data?.[key]?.ChartData?.map((item) => (
          <div
            className="bar-chart__item"
            style={{
              flex: item?.Percentage,
              backgroundColor: getStatusColor(item.Status),
            }}
          >
            {item?.Count}
          </div>
        ))}
      </div>

      <div className="bar-chart__name">
        {isAr ? data?.ArabicName : data?.EnglishName}
      </div>

      {detailsModal.isOpen && (
        <DetailsModal
          statuses={statuses || []}
          data={detailsModal.data}
          isOpen={detailsModal.isOpen}
          title={
            isProject ? "strategy-map.projects-list" : "strategy-map.kpis-list"
          }
          onClose={() => setDetailsModal(initialModalState)}
          isProject={isProject}
        />
      )}
    </Space>
  );
};

export default BarChart;
